import type { FaireProductEntity } from "../../entity_types/product";

export const p_6366n4xerh: FaireProductEntity = {
  token: "p_6366n4xerh",
  type: "product",
  name: "Japanese Foods Washi Stickers JP",
  brandToken: "b_m8c3mbnsfa",
  brandName: "Urban Tokyo",
  imageUrl: "https://cdn.faire.com/fastly/fc8e92857bba7b0745afe806bb987da99c1fe7e272f7a68c7d0cd9da9570c22e.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/56be28cbccc4d04a3ef05ee0977611d8cb53bbddd00ed93361d778bace1546a8.jpeg",
    "https://cdn.faire.com/fastly/eeb616fa5f9fcc73f07e1f334313af42960b97670d61354b355b4caabef9f201.jpeg"
  ],
  priceDollars: 2,
  description: "Add a touch of Japan to cards, gift wrap and journals with these Japanese Foods washi stickers. Made in Japan, they make an easy add-on for gift shops and checkout counters, and a fun souvenir for fans of Japanese design.\n\nFeatures\n\n * Japanese washi stickers: a classic Japanese craft item for scrapbooks, planners, letters and gift wrap \n * Collect the series: also available in Sakura, Warlord, Origami, O-Gi Fan, Maneki Neko, Origami Cranes, Ukiyo Mt. Fuji \nSpecifications\n\n * Type: Washi stickers \n * Design: Japanese Foods \n * Inner pack: 1 \n * Case pack: 100 \n * Origin: Japan ",
  tags: [],
  msrpDollars: 4.5,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-28T21:02:54.340Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
